import React, { ReactNode } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { MonitoringPermission } from "hooks/useAccess";
import { useHasPermission } from "hooks/useHasPermission";
import { useAuth } from "context/AuthContext";
import "./ProtectedPage.scss";

interface ProtectedPageProps {
  permission: MonitoringPermission;
  children: ReactNode;
}

const ProtectedPage: React.FC<ProtectedPageProps> = ({ permission, children }) => {
  const { loading } = useAuth();
  const allowed = useHasPermission(permission);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress />
      </Box>
    );
  }

  if (!allowed) {
    return (
      <div className="protected-page__denied">
        <LockOutlinedIcon className="protected-page__denied-icon" />
        <Typography variant="h6" fontWeight={600}>
          წვდომა შეზღუდულია
        </Typography>
        <Typography variant="body2" color="text.secondary">
          თქვენ არ გაქვთ ამ გვერდის ნახვის უფლება.
        </Typography>
      </div>
    );
  }

  return <>{children}</>;
};

export default ProtectedPage;
